import { CoolingOptions, PlatformOptions, TypeOptions } from '@/store/SiteSurveyForm/constants';

export interface OptionItem {
  label: string;
  value: string;
}
export interface ManualModeFormProps {
  fieldNamePath: (string | number)[];
  selectedPlatform: string;
  onPressureChange: (value: string, fieldPath: (string | number)[]) => void;
  onPlatformChange: () => void;
}

export interface SpecModeFormProps {
  fieldNamePath: (string | number)[];
  onPressureChange: (value: string, fieldPath: (string | number)[]) => void;
}

const mapValueToOption = (value: string): OptionItem => ({
  label: value,
  value: value,
});

export const createOptionsFromEnum = <T extends Record<string, string>>(enumObject: T): OptionItem[] => {
  return Object.values(enumObject).map(mapValueToOption);
};

export const createOptionsFromValues = (values: string[]): OptionItem[] => {
  return values.map(mapValueToOption);
};

export const typeOptions: OptionItem[] = createOptionsFromEnum(TypeOptions);

export const platformOptions: OptionItem[] = createOptionsFromEnum(PlatformOptions);

export const coolingOptions: OptionItem[] = createOptionsFromEnum(CoolingOptions);

export const getDriveTypeOptions = (selectedPlatform?: string): OptionItem[] => {
  if (selectedPlatform === PlatformOptions.CENTRIFUGAL) {
    const filteredValues = Object.values(TypeOptions).filter(
      value => value !== TypeOptions.FS && value !== TypeOptions.VSD,
    );
    return createOptionsFromValues(filteredValues);
  }

  return createOptionsFromEnum(TypeOptions);
};

export const INFORMATION_MODES = {
  SPEC: 'spec',
  MANUAL: 'manual',
} as const;

export type ModalMode = (typeof INFORMATION_MODES)[keyof typeof INFORMATION_MODES];

export interface AdditionalInformationModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  title?: string;
  fieldNamePath: (string | number)[];
  initialMode?: ModalMode;
}
